mutation TransactionNoteCreation($input: NoteInvoiceSigningCreateInput!) {
  noteInvoiceSigningCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
